import { dequal } from 'dequal';

export const assertDuplicateWithinWindow = (windowMs: number) => {
  let lastArgs: unknown = null;
  let timer: ReturnType<typeof setTimeout>;

  return (args: unknown) => {
    clearTimeout(timer);

    const isDuplicate = dequal(args, lastArgs);

    lastArgs = args;

    timer = setTimeout(() => {
      lastArgs = null;
    }, windowMs);

    return isDuplicate;
  };
};
